import React, { useState, useEffect, useRef, useContext, createContext } from "react";
import classNames from "classnames";
import { Route, useLocation, Redirect  } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "./AppTopbar";
import { AppFooter } from "./AppFooter";
import { AppMenu } from "./AppMenu";
import { AppConfig } from "./AppConfig";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/demo/flags/flags.css";
import "./assets/demo/Demos.scss";
import "./assets/layout/layout.scss";
import "./App.scss";

import {IntlProvider} from 'react-intl';
import en from './assets/i18n/en.json';
import it from './assets/i18n/it.json';


import Login from "./components/Auth/Login";
import { PrivateRoute } from "./PrivateRoute";
import ListaUtenti from "./components/Utenti/ListaUtenti";
import Azienda from "./components/Aziende/azienda";
import ListaFornitori from "./components/Fornitori/listaFornitori";
import Fornitore from "./components/Fornitori/Fornitore";
import ListaProdotti from "./components/Prodotti/listaProdotti";
import ListaProduzioni from "./components/Produzioni/listaProduzioni";
import ListaProcessi from "./components/Processi/listaProcessi";
import Utente from "./components/Utenti/Utente";
import Prodotto from "./components/Prodotti/Prodotto";
import ListaStabilimenti from "./components/Aziende/listaStabilimenti";
import Scheda from "./components/Prodotti/scheda";
import Stabilimento from "./components/Aziende/Stabilimento";
import ListaLotti from "./components/DettagliProdotto/listaLotti";
import ListaCertificazioni from "./components/Certificazioni/listaCertificazioni";
import ListaNotarizzazioni from "./components/Certificazioni/listaNotarizzazioni";
import Wallet from "./components/Auth/Wallet";
import SchedaAzienda from "./components/Aziende/SchedaAzienda";
import ReactGA from 'react-ga4';
import DashBoard from "./components/DashBoard";
import Supporto from "./components/Supporto";
import ListaClienti from "./components/Clienti/listaClienti";
import Cliente from "./components/Clienti/Cliente";
import constanti from "./constantiX"
import { Dialog } from "primereact";
import ListaStoria from "./components/Aziende/listaStoria";
import Config from "./components/Config";





const App = () => {


    const menu1 = useRef(null);
    const [layoutMode, setLayoutMode] = useState("static");
    const [layoutColorMode, setLayoutColorMode] = useState("light");
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(true);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const [contaclick, setContaclick] = useState(true);
    const [viewdgcook , setViewdgcook] = useState(localStorage.getItem("cocki")==null);
    const [cocki , setCocki] = useState(localStorage.getItem("cocki")==null);
    const [pageC , setPageC] = useState(false);
    const local = navigator.language;


let lang;
if (local === 'it-IT') {
       lang = it;
       localStorage.setItem('local','IT');
}else {
       lang = en;
       localStorage.setItem('local','EN');
       
}


    const [locale, setLocale] = useState(local);
    const [messages, setMessages] = useState(lang);
    
    const copyTooltipRef = useRef();
    const location = useLocation();
    
    
    const countries = [
       
        { name: 'English', code: 'UK' },
        { name: 'Italiano', code: 'IT' },
    ];
       

    //ReactGA.initialize(constanti.Analititcs);

    PrimeReact.ripple = true;

    let menuClick = true;
    let mobileTopbarMenuClick = false;

    let isAutenticate = (sessionStorage.getItem("isAutenticate")==true?true:false);

   


    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
        if(navigator.language=='it-IT'){
           // alert('ci sono')
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        const rehydrate1 = sessionStorage.getItem('isAutenticate');
        const ruolo = sessionStorage.getItem('ruoloid');
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
        if(contaclick && rehydrate1){
            setContaclick((prevState) => !prevState);
            setStaticMenuInactive((prevState) => !prevState);
        }
        
        setStaticMenuInactive(!rehydrate1);
        if(rehydrate1==null){
            setStaticMenuInactive(true);
        }else if(ruolo==='2'){
            setStaticMenuInactive(true);
        }

            
        
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode);
    };

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode);
    };

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;

      
    };

    const onClickPolicy = (e) => {
       alert('a');
    };

    const onClickCookies = (e) => {
        setPageC(true);
     };
 
    const onToggleMenuClick = (event) => {
        menuClick = true;
        isAutenticate=sessionStorage.getItem("isAutenticate");

        if(isAutenticate){
        if (isDesktop()) {
            if (layoutMode === "overlay") {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            } else if (layoutMode === "static") {
                setStaticMenuInactive((prevState) => !prevState);
            }
        } else {
            setMobileMenuActive((prevState) => !prevState);
        }
        }
     

        event.preventDefault();
    };


   const onLanguage = (event) => {
    
            if(event=='IT'){
                setLocale('it');
                setMessages(it);
                
                localStorage.setItem('local','IT');
            }else{
                setLocale('en');
                setMessages(en);
       
                localStorage.setItem('local','EN');
            }
    
    //this.setState({selLin:event});
        //alert(JSON.stringify(en))
        
    };

    const onSidebarClick = () => {
        menuClick = true;
    };

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;
        isAutenticate = (sessionStorage.getItem("isAutenticate")==true?true:false);
        //alert(sessionStorage.getItem("isAutenticate"));
        event.preventDefault();
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    };


    const onConfClick = (event) => {
       
            //alert('a');
      
       
    };


    const isDesktop = () => {
        return window.innerWidth >= 992;
    };

    
    var menu = [
        {
            items: [
                {
                    label: "Azienda",
                    icon: "pi pi-fw pi-sitemap",
                    items:(sessionStorage.getItem("LottoCliente")?
                     [
                        { label: "Dati Identificativi", icon: "pi pi-fw pi-id-card", to: "/azienda" },
                        { label: "Story Telling ", icon: "pi pi-fw pi-home", to: "/storia" },
                        { label: "_stabilimento_", icon: "pi pi-fw pi-home", to: "/listaStabilimenti" },
                         {label: "Fornitori", icon: "pi pi-fw pi-tags", to: "/listaFornitori" },
                        {label: "Clienti", icon: "pi pi-fw pi-tags", to: "/listaClienti" },
                        { label: "Prodotti", icon: "pi pi-fw pi-box", to: "/listaProdotti" },
                        { label: "Processi", icon: "pi pi-fw pi-briefcase", to: "/listaProcessi" },
                        
                    ]:
                    [
                        { label: "Dati Identificativi", icon: "pi pi-fw pi-id-card", to: "/azienda" },
                        { label: "Story Telling ", icon: "pi pi-fw pi-home", to: "/storia" },
                        { label: "_stabilimento_", icon: "pi pi-fw pi-home", to: "/listaStabilimenti" },
                         {label: "Fornitori", icon: "pi pi-fw pi-tags", to: "/listaFornitori" },
                        { label: "Prodotti", icon: "pi pi-fw pi-box", to: "/listaProdotti" },
                        { label: "Processi", icon: "pi pi-fw pi-briefcase", to: "/listaProcessi" },
                        
                    ])
                    ,
                },
                { label: "Utenti", icon: "pi pi-fw pi-users", to: "/listaUtenti" },            
                {
                    label: "Wallet",
                    icon: "pi pi-fw pi-wallet",
                    to: "/wallet" 
                },
                {
                    label: "Certificazioni",
                    icon: "pi pi-fw pi-qrcode",
                    items: [
                        { label: "Aziendali", icon: "pi pi-fw pi-building", to: "/certificazioni/aziendali" },
                        { label: "Prodotti", icon: "pi pi-fw pi-box", to: "/certificazioni/prodotti" },
                    ],
                },
                {
                    label: "Notarizzazioni",
                    icon: "pi pi-fw pi-book",
                    items: [{ label: "Lista", icon: "pi pi-fw pi-list", to: "/notarizazioni" }],
                },
               
            ],
        },
        {
            items: [{ label: "Supporto", icon: "pi pi-fw pi-at", to: "/supporto" }],
        },
        {
            items: [{ label: "Configurazione", icon: "pi pi-fw pi-cog", to: "/config" }],
        },
    ];

    const addClass = (element, className) => {
        if (element.classList) element.classList.add(className);
        else element.className += " " + className;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const wrapperClass = classNames("layout-wrapper", {
        "layout-overlay": layoutMode === "overlay",
        "layout-static": layoutMode === "static",
        "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
        "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
        "layout-mobile-sidebar-active": mobileMenuActive,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": ripple === false,
        "layout-theme-light": layoutColorMode === "light",
    });
  

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <AppTopbar lingua={(local=='it-IT'?countries[1]:countries[0])} onConfClick={onConfClick} onLanguageClick={onLanguage} onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
            <div className="layout-sidebar" onClick={onSidebarClick} ref={menu1}>
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
            </div>
            <div className="layout-main-container">
                <div className="layout-main">
               {/*
                <Route auth={sessionStorage.getItem('isAutenticate')}
                        path="/application/gridlist"
                        component={GridList}
                />
                */}  
                <IntlProvider messages={messages} locale={locale}>
          
             {/*          <Route exact path="/dashboard" component={DashBoard}/>
                  */}
               <Route exact path="/login" component={Login} />
                {/*       <Route exact path="/:sigla/schedapro/:id" component={Scheda} />
                    <Route exact path="/:sigla/schedaazi/:id" component={SchedaAzienda} />
                    <Route exact path="/scheda/:id" component={Scheda} />
                    <Route exact path="/scheda/azienda/:id" component={SchedaAzienda} />
                 */}
                </IntlProvider>

                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/azienda" component={Azienda}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/listaStabilimenti" component={ListaStabilimenti}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/Stabilimento/:id/:tipo" component={Stabilimento}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/listaUtenti" component={ListaUtenti}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/utente/:id/:tipo" component={Utente}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/listaFornitori" component={ListaFornitori}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/fornitore/:id/:tipo" component={Fornitore}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/listaClienti" component={ListaClienti}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/cliente/:id/:tipo" component={Cliente}/>
                <Route exact auth={isAutenticate} path="/listaProdotti" component={ListaProdotti}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/prodotto/:id/:tipo" component={Prodotto}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/listaProduzioni" component={ListaProduzioni}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/listaProcessi" component={ListaProcessi}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/listaLotti" component={ListaLotti}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/certificazioni/aziendali" component={ListaCertificazioni} tipo={'aziendali'}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/certificazioni/prodotti" component={ListaCertificazioni} tipo={'prodotti'}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/notarizazioni" component={ListaNotarizzazioni} tipo={'all'}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/wallet" component={Wallet}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/supporto" component={Supporto}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/storia" component={ListaStoria}/>
                <Route exact auth={sessionStorage.getItem('isAutenticate')} path="/config" component={Config}/>
           



                <Route exact path="/">
                    <Redirect to='/login' />
                </Route>
                     
                </div>



                <AppFooter layoutColorMode={layoutColorMode} onClickPolicy={onClickPolicy} onClickCookies={onClickCookies}/>
            </div>
    
            <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange} layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />
               
            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>

            <Dialog header="" visible={viewdgcook} position='bottom' modal style={{ width: '50vw' }} 
             onHide={() => {setViewdgcook(false)}}>
                        <p className="p-m-0">We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.</p>
                        <footer>
                    <div className="border-top-1 surface-border pt-3 mx-3">
                                <Button className="mx-4 align-right" type="button" icon="pi pi-check" onClick={() => {setViewdgcook(false),localStorage.setItem("cocki","V")}} label="Accept" />
                                <Button className="mx-4" type="button" icon="pi pi-check" onClick={() =>  {setViewdgcook(false),localStorage.setItem("cocki","N")}} label="Decline" />
                    </div>
            </footer>
          </Dialog>
          <Dialog header="" visible={pageC} position='bottom' modal style={{ width: '100%' }} 
             onHide={() => setPageC(false)}>

            <div>
            COOKIE POLICY<br/>
            </div>

                        <footer>
                    <div className="border-top-1 surface-border pt-3 mx-3">

                                <Button className="mx-2 align-right" type="button" icon="pi pi-check" onClick={() => setPageC(false)} label="Accept" />
                                <Button className="mx-2" type="button" icon="pi pi-check" onClick={() =>  setPageC(false)} label="Decline" />
                    </div>
            </footer>
          </Dialog>
        </div>
    );
};

export default App;
